import React, { PureComponent } from "react";
import {
  SelectIcon,
  StarIcon,
  WinnerIconWrapper,
  WinnerIcon,
  RunnerNumberAtom,
  ScratchedBoxIconContainer,
  AlternateIconContainer
} from "./styled-components";
import getColor from "./SaddleColors";
import {
  starOutlineFill,
  arrowDown,
  star,
  tick
} from "../../_static/Icons/icons";
import { scratchedBox } from "../../_static/Icons/iconsDuotone";
import buildColor from "../../_static/ColorPalette";
import Icon from "../../_static/Icons";

const DoubleArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_12166_13982)">
      <path
        d="M5.5 5.4999C5.5 5.77604 5.72386 5.9999 6 5.9999L11.6667 5.9999L10.4187 7.31024C10.2283 7.51021 10.236 7.8267 10.436 8.01714L11.1601 8.7068C11.2561 8.79825 11.3845 8.84781 11.5171 8.84458C11.6497 8.84134 11.7755 8.78558 11.867 8.68955L14.7241 5.68955C15.092 5.30335 15.092 4.69645 14.7241 4.31024L11.867 1.31024C11.7755 1.21422 11.6497 1.15845 11.5171 1.15522C11.3845 1.15199 11.2561 1.20155 11.1601 1.293L10.436 1.98266C10.236 2.1731 10.2283 2.48959 10.4187 2.68955L11.6667 3.9999L6 3.9999C5.86739 3.9999 5.74021 4.05258 5.64645 4.14635C5.55268 4.24011 5.5 4.36729 5.5 4.4999L5.5 5.4999Z"
        fill="white"
        stroke="#05285A"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.5001C10.5 10.3675 10.4473 10.2403 10.3536 10.1465C10.2598 10.0528 10.1326 10.0001 10 10.0001L4.33333 10.0001L5.58128 8.68976C5.67273 8.59373 5.72229 8.46531 5.71906 8.33274C5.71583 8.20017 5.66006 8.07431 5.56404 7.98286L4.8399 7.2932C4.63993 7.10276 4.32345 7.11048 4.133 7.31045L1.27586 10.3104C0.908046 10.6967 0.908046 11.3035 1.27586 11.6898L4.133 14.6898C4.22446 14.7858 4.35031 14.8415 4.48288 14.8448C4.61545 14.848 4.74387 14.7985 4.8399 14.707L5.56404 14.0173C5.764 13.8269 5.77172 13.5104 5.58128 13.3104L4.33333 12.0001L10 12.0001C10.2761 12.0001 10.5 11.7762 10.5 11.5001L10.5 10.5001Z"
        fill="white"
        stroke="#05285A"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12166_13982">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default class RunnerNumber extends PureComponent {
  static defaultProps = {
    qaLabel: "runnerNumber",
    runnerId: "",
    raceTypeCode: "T",
    isFavorite: false,
    arrowDirection: "none",
    isBetsStandalone: false,
    isScratched: false,
    isAllRunners: false,
    isWinnerBI: false,
    isActiveMultiRaceLegOver: false,
    isRaceOver: false,
    isBetsDetailedView: false,
    isUnknownWinnerStatus: false,
    isAlternate: false
  };

  render() {
    const saddle = getColor(
      this.props.raceTypeCode,
      parseInt(this.props.runnerId, 10)
    );

    return (
      <RunnerNumberAtom
        data-qa-label={`${this.props.qaLabel}-${this.props.runnerId}`}
        saddleColor={
          !this.props.isAllRunners
            ? this.props.saddleColor || saddle.saddleColor
            : buildColor("blue", "100")
        }
        numberColor={
          !this.props.isAllRunners
            ? this.props.numberColor || saddle.numberColor
            : buildColor("black", "100")
        }
        gradient={
          !this.props.isAllRunners ? saddle.gradient : buildColor("blue", "100")
        }
        textShadow={saddle.textShadow}
        isFavorite={this.props.isFavorite}
        border={saddle.border}
        flexDirection={this.props.arrowDirection !== "none" ? "column" : "row"}
        isRotated={this.props.arrowDirection === "up"}
        isBetsStandalone={this.props.isBetsStandalone}
        isScratched={this.props.isScratched}
        isWinnerBI={this.props.isWinnerBI}
        isActiveMultiRaceLegOver={this.props.isActiveMultiRaceLegOver}
        isBetsDetailedView={this.props.isBetsDetailedView}
        isAllRunners={this.props.isAllRunners}
        isRaceOver={this.props.isRaceOver}
        isUnknownWinnerStatus={this.props.isUnknownWinnerStatus}
      >
        {this.props.isAlternate && (
          <AlternateIconContainer>
            <DoubleArrowIcon />
          </AlternateIconContainer>
        )}
        {this.props.isBetsStandalone && this.props.isScratched && (
          <ScratchedBoxIconContainer>
            <Icon
              icon={scratchedBox}
              viewBoxSize={20}
              size={20}
              color={buildColor("grey", "900")}
            />
          </ScratchedBoxIconContainer>
        )}
        {this.props.isWinnerBI && !this.props.isScratched && (
          <WinnerIconWrapper>
            <WinnerIcon
              size={8}
              icon={tick}
              color={buildColor("green", "000")}
            />
          </WinnerIconWrapper>
        )}
        {this.props.isFavorite && (
          /* TODO update icon according to design for bet standalone */
          <StarIcon
            size={this.props.isBetsStandalone ? 12 : 9}
            icon={this.props.isBetsStandalone ? star : starOutlineFill}
            color={buildColor("yellow", "500")}
            isBetsStandalone={this.props.isBetsStandalone}
          />
        )}
        {!this.props.runnerId ? "?" : this.props.runnerId}
        {this.props.arrowDirection !== "none" && (
          <SelectIcon
            isRotated={this.props.arrowDirection === "up"}
            icon={arrowDown}
            size={12}
            color={saddle.numberColor}
          />
        )}
      </RunnerNumberAtom>
    );
  }
}
